import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const baseClassName =
  "inline-flex h-5 w-fit shrink-0 items-center justify-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap";

export default function ToolResultBadge({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return <span className={cn(baseClassName, className)}>{children}</span>;
}
